export default class ApolloResponseError extends Error {
  constructor(message: string, public extra?: any) {
    super(message)

    Object.setPrototypeOf(this, ApolloResponseError.prototype)
  }
}
